import { extractCallInviteIdFromSignal } from '../calls/callLegSignal';

/**
 * Положить сигнальный кадр в буфер чата, у которого сейчас нет экрана звонка.
 *
 * <p>Буфер нужен, чтобы экран звонка, открытый позже кадров, получил их все (offer, ICE). Но
 * он живёт, пока экран не подпишется, — и переживает звонки, до экрана так и не дошедшие.
 * Пропущенный вызов (звонящий передумал) или вызов, принятый на другом нашем устройстве,
 * оставлял в нём свои `invite` и `bye`. Следующий принятый звонок получал их первыми: старый
 * `invite` давал звонящему «занято», старый `bye` закрывал только что принятый разговор
 * (прогон на эмуляторе 2026-09-27: ответ на телефоне после пропущенного обрывался всегда).
 *
 * <p>Поэтому `invite` начинает буфер заново: кадры до него относятся к звонку, которого на
 * этом устройстве уже нет. Остаются только кадры той же «ноги» — повторная отправка того же
 * приглашения, пока звонящий ждёт, не должна терять то, что пришло между повторами.
 */
export function appendSignalBacklog(buf: string[], raw: string, max: number): string[] {
  const frame = parseFrame(raw);
  let next = buf;
  if (frame && String(frame.signalType ?? '').toLowerCase() === 'invite') {
    const leg = extractCallInviteIdFromSignal(frame);
    next = buf.filter((earlier) => {
      const e = parseFrame(earlier);
      return leg != null && e != null && extractCallInviteIdFromSignal(e) === leg;
    });
  }
  next = [...next, raw];
  return next.length > max ? next.slice(next.length - max) : next;
}

function parseFrame(raw: string): Record<string, unknown> | null {
  try {
    const j: unknown = JSON.parse(raw);
    return j !== null && typeof j === 'object' ? (j as Record<string, unknown>) : null;
  } catch {
    return null;
  }
}
